import React, { useEffect, useState } from "react";
import "./ServicesCount.css";
import ServiceBody from "./ServiceBody";
import ServiceBanner from "./ServiceBanner";
import { GetContent } from "../../../Api/Api";
import { useParams } from "react-router-dom";
import { useSelector } from "react-redux";

export default function SpecificServicesComponent() {

  const { id } = useParams(); // ✅ GET ID FROM URL
  const state = useSelector((state) => state);

  const [content, setContent] = useState([]);
  const [loading, setLoading] = useState(true);

  /* ---------------- FETCH SERVICE CONTENT ---------------- */
  const fetchServiceContent = async () => {
    try {
      if (!id) return;

      const data = await GetContent("active", id);

      if (data?.statusCode === 200) {
        setContent(data.data);
      } else {
        setContent([]);
      }
    } catch (error) {
      console.error("Service fetch failed:", error);
      setContent([]);
    }

    setLoading(false);
  };

  /* ---------------- EFFECT ---------------- */
  useEffect(() => {
    window.scrollTo(0, 0);
    fetchServiceContent();
  }, [id]); // ✅ Re-run when ID changes

  /* ---------------- LOADING STATE ---------------- */
  if (loading) {
    return <div className="text-center py-5">Loading service...</div>;
  }

  if (!content?.length) {
    // return <div className="text-center py-5">Service not found</div>;
  }

  /* ---------------- RENDER ---------------- */
  return (
    <div>
      <ServiceBanner contentProps={content} stateProps={state} />
      <ServiceBody contentProps={content} stateProps={state} />
    </div>
  );
}